import { uniqueId } from "lodash";


interface TemplateReplaceItem {
  url?: string;
  label?: string;
  [key: string]: unknown;
}

interface MessageTemplate {
  message?: string;
  replace_with?: Record<string, TemplateReplaceItem>;
}

interface MessageObj {
  message?: string;
  template?: MessageTemplate | null;
}

export const wrapStringWithLink = (messageObj: MessageObj): React.ReactNode => {
  const { message, template = null } = messageObj;

  const trimmedMessage = message?.trim();

  if (!trimmedMessage) return '';

  if (template) {
    // the replaceable text format should be like this <<<key_name>>>
    const templateRegex = /<<<<([a-z_]+)>>>>/g;

    const trimmedTemplateMessage = template?.message?.trim();

    if (trimmedTemplateMessage && templateRegex?.test(trimmedTemplateMessage)) {
      const splittedMessage = trimmedTemplateMessage?.split(templateRegex) || [];
      const parts = splittedMessage?.map((part) => {
        const messageData = template?.replace_with?.[part];
        if (Object.keys(messageData || {})?.length) {
          return (
            <a
              key={uniqueId()}
              href={messageData?.url}
              target="_blank"
              rel="noopener noreferrer"
              className="message-link"
            >
              {messageData?.label}
            </a>
          );
        }
        return part;
      });
      return parts;
    }
  }

  // Extended regular expression to detect http, https, wss, and www links
  const urlRegex = /(https?:\/\/[^\s]+|wss:\/\/[^\s]+|www\.[^\s]+)/g;

  if (urlRegex?.test(trimmedMessage)) {
    const parts = trimmedMessage?.split(urlRegex).map((part) => {
      if (urlRegex?.test(part)) {
        // Ensure URLs that don't start with http/https get 'http://' prefixed for anchor tags
        const href = part?.startsWith('http') || part?.startsWith('wss') ? part : `http://${part}`;
        return (
          <a
            key={uniqueId()}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="message-link"
          >
            {part}
          </a>
        );
      }
      return part;
    });
    return parts;
  }

  return trimmedMessage;
};